import { client } from ".";

/**
 * Fetch the earnings summary tiles (Today / Week / Month / Lifetime).
 */
export const getEarningsSummary = async (astrologerId, accessToken) => {
  try {
    const response = await client.get(
      `/api/astrologer/earnings/summary/${astrologerId}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return { status: response.status, data: response.data.data };
  } catch (err) {
    console.error("Error fetching earnings summary:", err);
    return { status: err.response?.status || 500, error: err.message, data: null };
  }
};

/**
 * Fetch the earnings sessions (drill-down list).
 */
export const getEarningsSessions = async (astrologerId, accessToken, { page = 1, limit = 20, startDate, endDate } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);

    const response = await client.get(
      `/api/astrologer/earnings/sessions/${astrologerId}?${params.toString()}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return { status: response.status, data: response.data.data };
  } catch (err) {
    console.error("Error fetching earnings sessions:", err);
    return { status: err.response?.status || 500, error: err.message, data: null };
  }
};
